// Each guide's own file, loaded when its page opens (App.tsx): a guide page used to load all of
// them, every language, ~118 KB compressed. growth/content/guides.js still has the whole map for
// the tests and scripts; seo.test.jsx keeps the two in step.
export const GUIDE_LOADERS = {
  monetize: () => import('./guideMonetize'),
  'canal-dark': () => import('./guideCanalDark'),
  'ypp-2027': () => import('./guideYpp2027'),
  'youtube-requirements': () => import('./guideYoutubeRequirements'),
  'capcut-pro-price': () => import('./guideCapcutPrice'),
  'video-sizes': () => import('./guideVideoSizes'),
  facebook: () => import('./guideFacebook'),
  'tiktok-rewards': () => import('./guideTikTok'),
  platforms: () => import('./guidePlatforms'),
  instagram: () => import('./guideInstagram'),
  captions: () => import('./guideCaptions'),
  dubbing: () => import('./guideDubbing'),
  'clips-channel': () => import('./guideClips'),
  'shorts-monetization': () => import('./guideShorts'),
  'x-creators': () => import('./guideX'),
  snapchat: () => import('./guideSnapchat'),
  kwai: () => import('./guideKwai'),
  'tiktok-live': () => import('./guideTikTokLive'),
  'youtube-fans': () => import('./guideYouTubeFans'),
  'facebook-stars': () => import('./guideFacebookStars'),
  'ai-labels': () => import('./guideAiLabels'),
  'ai-money': () => import('./guideAiMoney'),
  spotify: () => import('./guideSpotify'),
  'ai-drama': () => import('./guideAiDrama'),
  'best-ai-video-tools': () => import('./guideBestTools'),
  'size-youtube-shorts': () => import('./guideSizeYouTube'),
  'size-tiktok': () => import('./guideSizeTikTok'),
  'size-instagram-reels': () => import('./guideSizeInstagram'),
  'size-facebook-reels': () => import('./guideSizeFacebook'),
  'size-snapchat': () => import('./guideSizeSnapchat'),
  'size-pinterest': () => import('./guideSizePinterest'),
  'size-linkedin': () => import('./guideSizeLinkedIn'),
  'size-x': () => import('./guideSizeX'),
  'reused-content': () => import('./guideReused'),
  'best-ai-clipping-tools': () => import('./guideBestClipping'),
  'best-ai-voiceover-tools': () => import('./guideBestVoiceover'),
  'rule-changes': () => import('./guideRuleChanges'),
  'gulf-pay': () => import('./guideGulfPay'),
  'gulf-ad-cost': () => import('./guideGulfAdCost'),
  'kwai-contract': () => import('./guideKwaiContract'),
  'kwai-booster': () => import('./guideKwaiBooster'),
  'kwai-posting': () => import('./guideKwaiPosting'),
  'youtube-pay-per-view': () => import('./guideYouTubePayPerView'),
  'shorts-money': () => import('./guideShortsMoney'),
  'grow-channel': () => import('./guideGrowChannel'),
  'tiktok-money': () => import('./guideTikTokMoney'),
  'instagram-reels-money': () => import('./guideInstagramReelsMoney'),
  'facebook-reels-money': () => import('./guideFacebookReelsMoney'),
  // Spanish and Portuguese only: the English reader's page is the blog post /blog/long-videos-to-tiktoks
  'long-video-clips': () => import('./guideLongVideoClips'),
  // Latin America in English and Spanish; Brazil and Portugal in Portuguese only
  'latam-pay': () => import('./guideLatamPay'),
  'brasil-pay': () => import('./guideBrasilPay'),
};
